import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import { useSelector } from "react-redux";
import ErrorModal from './ErrorModal';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'; // Import green and red icons
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const batchURI= process.env.REACT_APP_API_BATCH_URL;

const BoardCustomer = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [places, setPlace] = useState([]);
  const [subvos, setSubVos] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [notificationState, setNotificationState] = useState(false);
 
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [tariffs, setTariffs] = useState([]);
  const [filterTerm, setFilterTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [statuses, setStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Loading, please wait...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state
  const headers = [
    { label: 'Company Name', key: 'custumer_company_name' },
    { label: 'Company Email', key: 'custumer_company_email' },
    { label: 'Contact First Name', key: 'custumer_contact_firstname' },
    { label: 'Contact Last Name', key: 'custumer_contact_lastname' },
    { label: 'Contact Mobile', key: 'custumer_contact_mobile' },
    { label: 'Postal Code', key: 'custumer_postal_code' },
    { label: 'City', key: 'custumer_city' },
    { label: 'City Additional', key: 'custumer_city_add' },
    { label: 'Street', key: 'custumer_str' },
    { label: 'Street Number', key: 'custumer_street_number' },
    { label: 'Street Additional', key: 'custumer_street_add' },
    { label: 'Tax Number', key: 'custumer_tax_number' },
    { label: 'Tax ID', key: 'custumer_tax_id' },
    { label: 'Tariff ID', key: 'tariff_id' },
    { label: 'Batch Status ID', key: 'batch_status_id' },
    { label: 'Batch Validity From', key: 'batch_validity_from' },
    { label: 'Batch Validity Until', key: 'batch_validity_until' }
];
  
  const initialState = {
    tariffs: [],
    // other state properties
  };

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page

    const handleDownloadExcel = () => {
      // Map and format the data to include the specified fields
      const filteredData = sortedMainVOs.map(({
        custumer_company_name,
        custumer_company_email,
        custumer_contact_firstname,
        custumer_contact_lastname,
        custumer_contact_mobile,
        custumer_postal_code,
        custumer_city,
        custumer_city_add,
        custumer_str,
        custumer_street_number,
        custumer_street_add,
        custumer_tax_number,
        custumer_tax_id,
        tariff_id,
        batch_status_id,
        batch_validity_from,
        batch_validity_until,
      }) => ({
        custumer_company_name,
        custumer_company_email,
        custumer_contact_firstname,
        custumer_contact_lastname,
        custumer_contact_mobile,
        custumer_postal_code,
        custumer_city,
        custumer_city_add,
        custumer_str,
        custumer_street_number,
        custumer_street_add,
        custumer_tax_number,
        custumer_tax_id,
        tariff_id,
        batch_status_id,
        batch_validity_from,
        batch_validity_until,
      }));
    
      // Create a new workbook and a worksheet with the specified headers
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(filteredData, {
        header: [
          'custumer_company_name',
          'custumer_company_email',
          'custumer_contact_firstname',
          'custumer_contact_lastname',
          'custumer_contact_mobile',
          'custumer_postal_code',
          'custumer_city',
          'custumer_city_add',
          'custumer_str',
          'custumer_street_number',
          'custumer_street_add',
          'custumer_tax_number',
          'custumer_tax_id',
          'tariff_id',
          'batch_status_id',
          'batch_validity_from',
          'batch_validity_until'
        ]
      });
    
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
      // Generate an Excel file and download it
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, 'customer_data.xlsx');
    };
    


/*
  "custumer_company_name": "ABC Corp",
  "custumer_company_email": "sg@tenios.de",
  "custumer_contact_firstname": "John",
  "custumer_contact_lastname": "Doe",
  "custumer_contact_mobile": "+1234567890",
  "custumer_postal_code": "12345",
  "custumer_city": "Some City",
  "custumer_city_add": "Additional City Info",
  "custumer_str": "Main Street",
  "custumer_street_number": "123",
  "custumer_street_add": "Apt 4B",
  "custumer_tax_number": "VAT123456",
  "custumer_tax_id": "TAXID123456",
  "rec_dat": "2024-01-01",
  "t_sub_vo": {
      "sub_vo_id": 1,
      "company_name": "Sub VO Company"
  }
}
*/
  const [formData, setFormData] = useState({
    custumer_company_name: "",
    custumer_company_email: "",
    custumer_contact_firstname: "",
    custumer_contact_lastname: "",
    custumer_contact_mobile: "",
    custumer_postal_code: "",
    custumer_city: "",
    custumer_city_add: "",
    custumer_str: "",
    custumer_street_number: "",
    custumer_street_add: "",
    custumer_tax_number: "",
    custumer_tax_id: "",
    t_sub_vo: { sub_vo_id: 0,company_name: "" },
    t_place_id: { place_id_nr: 0,place_id: "" },
    tariff_id:0,
    batch_status_id:0,
    batch_validity_from:'',
    batch_validity_until:'',
    });

  const validateForm = () => {
    const newErrors = {};
    
    // Validate company_name
    if (!formData.custumer_company_name.trim()) {
      newErrors.custumer_company_name = 'Company Name is required';
    }
  
    // Validate company_mobile_number (example: must be a valid phone number)
    if (!formData.custumer_contact_mobile.trim()) {
      newErrors.custumer_contact_mobile = 'Company Mobile Number is required';
    } else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.custumer_contact_mobile)) {
      newErrors.custumer_contact_mobile = 'Company Mobile Number must be a valid phone number';
    }
  
    // Validate company_email (example: must be a valid email)
    if (!formData.custumer_company_email.trim()) {
      newErrors.custumer_company_email = 'Company Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.custumer_company_email)) {
      newErrors.custumer_company_email = 'Company Email must be a valid email address';
    }
  
    // Validate contact_first_name
    if (!formData.custumer_contact_firstname.trim()) {
      newErrors.custumer_contact_firstname = 'Contact First Name is required';
    }
  
    // Validate contact_last_name
    if (!formData.custumer_contact_lastname.trim()) {
      newErrors.custumer_contact_lastname = 'Contact Last Name is required';
    }
  
    // Validate Place ID
    if (!formData.t_place_id.place_id_nr || isNaN(formData.t_place_id.place_id_nr)) {  
      newErrors.place_id_nr = 'Invalid Place ID: Place ID must be defined';
    } else if (parseInt(formData.t_place_id.place_id_nr) <= 0) {
      newErrors.place_id_nr = 'Invalid Place ID: Place ID must be a number greater than 0.';
    }
    if (!formData.tariff_id || isNaN(formData.tariff_id)) {  
      newErrors.tariff_id = 'Invalid Teriff ID: Tariff ID must be defined';
    } else if (parseInt(formData.tariff_id) <= 0) {
      newErrors.tariff_id_id = 'Invalid Tariff ID: Teriff ID must be a number greater than 0.';
    }
    if (!formData.batch_status_id || isNaN(formData.batch_status_id)) {  
      newErrors.tariff_id = 'Invalid Status ID: Invalid Status ID must be defined';
    } else if (parseInt(formData.batch_status_id) <= 0) {
      newErrors.status_id = 'Invalid Status ID: Status ID must be a number greater than 0.';
    }



    
    // Validate `batch_validity_from` Date
  if (!formData.batch_validity_from) {
    newErrors.batch_validity_from = 'Invalid Date: Start date must be defined.';
  } else if (isNaN(Date.parse(formData.batch_validity_from))) {
    newErrors.batch_validity_from = 'Invalid Date: Start date must be a valid date.';
  }

  // Validate `batch_validity_until` Date
  if (!formData.batch_validity_until) {
    newErrors.batch_validity_until = 'Invalid Date: End date must be defined.';
  } else if (isNaN(Date.parse(formData.batch_validity_until))) {
    newErrors.batch_validity_until = 'Invalid Date: End date must be a valid date.';
  }

  // Check date order: `batch_validity_from` should be earlier than `batch_validity_until`
  if (
    formData.batch_validity_from &&
    formData.batch_validity_until &&
    Date.parse(formData.batch_validity_from) >= Date.parse(formData.batch_validity_until)
  ) {
    newErrors.batch_validity_until = 'Invalid Date Range: End date must be later than start date.';
  }


    if(currentUser.roles.includes("ROLE_ADMIN") )
    {
    // Validate Sub VO ID
    if (!formData.t_sub_vo.sub_vo_id || isNaN(formData.t_sub_vo.sub_vo_id)) {  
      newErrors.sub_vo_id = 'Invalid Sub VO ID: Sub VO ID must be defined';
    } else if (parseInt(formData.t_sub_vo.sub_vo_id) <= 0) {
      newErrors.sub_vo_id = 'Invalid Sub VO ID: Sub VO ID must be a number greater than 0.';
    }
    }
    // Extended Validation for New Fields
  
    // Validate custumer_postal_code
    if (!formData.custumer_postal_code.trim()) {
      newErrors.custumer_postal_code = 'Postal Code is required';
    } else if (!/^\d{5}$/.test(formData.custumer_postal_code)) {
      newErrors.custumer_postal_code = 'Postal Code must be a valid 5-digit number';
    }
  
    // Validate custumer_city
    if (!formData.custumer_city.trim()) {
      newErrors.custumer_city = 'City is required';
    }
  
    // Validate custumer_city_add (optional field, no trim)
    if (formData.custumer_city_add && !formData.custumer_city_add.trim()) {
      newErrors.custumer_city_add = 'Additional City Info must not be empty';
    }
  
    // Validate custumer_str (Street)
    if (!formData.custumer_str.trim()) {
      newErrors.custumer_str = 'Street is required';
    }
  
    // Validate custumer_street_number
    if (!formData.custumer_street_number.trim()) {
      newErrors.custumer_street_number = 'Street Number is required';
    } else if (!/^\d+$/.test(formData.custumer_street_number)) {
      newErrors.custumer_street_number = 'Street Number must be a valid number';
    }
  
    // Validate custumer_street_add (optional field, no trim)
    if (formData.custumer_street_add && !formData.custumer_street_add.trim()) {
      newErrors.custumer_street_add = 'Street Add must not be empty';
    }
  
    // Validate custumer_tax_number (optional validation)
    if (formData.custumer_tax_number && !/^[A-Za-z0-9]+$/.test(formData.custumer_tax_number)) {
      newErrors.custumer_tax_number = 'Tax Number must be alphanumeric';
    }
  
    // Validate custumer_tax_id (optional validation)
    if (formData.custumer_tax_id && !/^[A-Za-z0-9]+$/.test(formData.custumer_tax_id)) {
      newErrors.custumer_tax_id = 'Tax ID must be alphanumeric';
    }
  
    // Finalize validation
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  

  useEffect(() => {
    
    UserService.getTariffBoard().then(
      (response) => {
        setTariffs(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setTariffs(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});

    UserService.getStatusBoard().then(
      (response) => {
        setStatus(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setStatus(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});


    UserService.getCustomerBoard().then(
      (response) => {
        setCustomer(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setCustomer(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
    
    UserService.getSubVosBoard().then(
      (response) => {
        setSubVos(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setSubVos(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
    
    UserService.getPlacesBoardWB().then(
      (response) => {
        setPlace(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 

        setPlace(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);

  useEffect(() => {
    validateForm();
  }, [formData]); // This will run every time formData is updated



  // Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(customer)
? customer.filter((vo) =>
  
    (vo.custumer_company_name && vo.custumer_company_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo?.t_sub_vo?.company_name && vo.t_sub_vo.company_name.toLowerCase().includes(filterTerm.toLowerCase())) ||      
    (vo?.t_place_id?.place_id && vo.t_place_id.place_id.toLowerCase().includes(filterTerm.toLowerCase())) ||      
    (vo.custumer_contact_mobile && vo.custumer_contact_mobile.includes(filterTerm)) ||
    (vo.custumer_company_email && vo.custumer_company_email.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.custumer_contact_firstname && vo.custumer_contact_firstname.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.custumer_contact_lastname && vo.custumer_contact_lastname.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.rec_dat && vo.rec_dat.includes(filterTerm))
  )
: [];


 // Get the current page's data
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);
 
  // Handle pagination
 const handlePageChange = (pageNumber) => {
   setCurrentPage(pageNumber);
 };
 
 // Sorting function
 const handleSort = (key) => {
   let direction = 'asc';
   if (sortConfig.key === key && sortConfig.direction === 'asc') {
     direction = 'desc';
   }
   setSortConfig({ key, direction });
 };
 
 
 
 const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
   let aValue, bValue;
   
   // Handle nested properties for sorting
   if (sortConfig.key === 't_sub_vo.company_name') {
    aValue = a.t_sub_vo?.company_name || '';
    bValue = b.t_sub_vo?.company_name || '';
    } 
    else if (sortConfig.key === 't_place_id.place_id') {
      aValue = a.t_place_id?.place_id || '';
      bValue = b.t_place_id?.place_id || '';
    } 
    else {
     // For non-nested keys
     aValue = a[sortConfig.key];
     bValue = b[sortConfig.key];
   }
 
   // Perform the comparison based on direction
   if (aValue < bValue) {
     return sortConfig.direction === 'asc' ? -1 : 1;
   }
   if (aValue > bValue) {
     return sortConfig.direction === 'asc' ? 1 : -1;
   }
   return 0;
 });
 
 
 // Total pages calculation
 const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);

  const handleEditClick = (customer) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedCustomer(customer);
    console.log(customer);
    setFormData(customer);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
    custumer_company_name: "",
    custumer_company_email: "",
    custumer_contact_firstname: "",
    custumer_contact_lastname: "",
    custumer_contact_mobile: "",
    custumer_postal_code: "",
    custumer_city: "",
    custumer_city_add: "",
    custumer_str: "",
    custumer_street_number: "",
    custumer_street_add: "",
    custumer_tax_number: "",
    custumer_tax_id: "",
    tariff_id:0,
    batch_status_id:0,
    batch_validity_from:'',
    batch_validity_until:'',
    
    t_sub_vo: { sub_vo_id: 0,company_name: "" },
    t_place_id: { place_id_nr: 0,place_id: "" },
    });
    setShowCreateModal(true);
  };


  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText(' Deleting the data please wait...');
      setLoading(true);
      await UserService.deleteCustomerBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Customer:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleNotificationClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText(' Notification the data please wait...');
      setLoading(true);
      await UserService.sendNotificationBoardReset(id);
      setNotificationState(prev => !prev);
      console.info(notificationState);
    } catch (error) {
      console.error('Error Sending Notification to the Customer:', error);
   
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      //setApiErrors(`Error: ${error.name}-${error.code}`);
   
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error Sending Notification to the Customer:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText(' Updating the data please wait...');
      setLoading(true);
      //formData.rec_date = new Date();
      await UserService.updateCustomerBoard(selectedCustomer.customer_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error updating Customer:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  


  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText(' Creating the data please wait...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createCustomerBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error creating Customer:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
  const name = e.target.name;
  const value = e.target.value;
  console.log("Select Name:"+e.target.name);
  console.log("Select Value before :"+value);
 
  if (name === "sub_vo_id") {
    
    setFormData((prevState) => ({
      ...prevState,
      t_sub_vo: {
        ...prevState.t_sub_vo,  // Keep the rest of t_customer intact
        sub_vo_id: value,      // Update only the customer_id
      },
    }));
  }else if (name === "place_id_nr") {
    
    setFormData((prevState) => ({
      ...prevState,
      t_place_id: {
        ...prevState.t_place_id,  // Keep the rest of t_customer intact
        place_id_nr: value,      // Update only the customer_id
      },
    }));
  }
 
    else {
    // Handle all other input updates
    setFormData({
      ...formData,
      [name]: value,
    });
    
    
  }
  if (!validateForm()) return; 
  console.log("Updated formData:", formData);
};

 const handleCloseModal = () => setShowModal(false);
  

  return (

    <Container className="d-flex justify-content-center mt-5" style={{ minWidth: '80%' }}>
      <div className="table-responsive" style={{ width: '100%' }}>
       
    
      <h1 className="mt-12">Customer Overview</h1>
      {/* Display error if it exists */}
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />    
      
      <CSVLink data={sortedMainVOs} headers={headers} filename={"customer_data.csv"}>
      <Button variant="warning" className="mr-2 mb-2">Download CSV</Button>
      </CSVLink>

     
      <Button onClick={handleDownloadExcel} variant="danger" className="mr-2 mb-2">Download as Excel</Button>
      

      {/*<Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Create
      </Button>*/}

      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only"> Loading...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
       {/* Filter Input */}
       <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Search by Tariff name, id and rect date"
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      <Table striped bordered hover className="text-center align-middle" style={{ width: '100%' }}>
    
        <thead>
          <tr>
        
            {/* Sortable column headers */}
            <th onClick={() => handleSort('customer_id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'customer_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('t_status.status_id')} style={{ cursor: 'pointer' }}>
            Batch-Status {sortConfig.key === 't_status.status_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('t_sub_vo.company_name')} style={{ cursor: 'pointer' }}>
            Sub Vo Name {sortConfig.key === 't_sub_vo.company_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('t_place_id.place_id')} style={{ cursor: 'pointer' }}>
            Place Name-ID {sortConfig.key === 't_place_id.place_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('custumer_company_name')} style={{ cursor: 'pointer' }}>
            Company Name {sortConfig.key === 'custumer_company_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('custumer_contact_mobile')} style={{ cursor: 'pointer' }}>
            Company Mobile {sortConfig.key === 'custumer_contact_mobile' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('custumer_company_email')} style={{ cursor: 'pointer' }}>
            Company Email {sortConfig.key === 'custumer_company_email' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('custumer_contact_firstname')} style={{ cursor: 'pointer' }}>
            Contact First Name {sortConfig.key === 'custumer_contact_firstname' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('custumer_contact_lastname')} style={{ cursor: 'pointer' }}>
            Contact Last Name {sortConfig.key === 'custumer_contact_lastname' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('qrCode')} style={{ cursor: 'pointer' }}>
            QR-Code {sortConfig.key === 'qrCode' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
           
            <th onClick={() => handleSort('rec_dat')} style={{ cursor: 'pointer' }}>
            Registration Date {sortConfig.key === 'rec_dat' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
           <th>Actions</th>
          </tr>
        </thead>
      
        <tbody>
          {sortedMainVOs.map((vo) => (
            <tr key={vo.customer_id}>
              <td>{vo.customer_id}</td>
              <td style={{ padding: '10px', textAlign: 'center' }}>
              {/* Conditional rendering based on the status */}
              {vo.t_status && vo.t_status.status_id === 1 ? (
                <FaCheckCircle size={24} style={{ color: 'green' }} /> // Green check icon
              ) : (
                <FaTimesCircle size={24} style={{ color: 'red' }} /> // Red cross icon
              )}
            </td>
              <td>{vo.t_sub_vo.company_name}</td>
              <td>{vo.t_place_id?.place_id || 'No Place ID'}</td>
              <td>{vo.custumer_company_name}</td>
              <td>{vo.custumer_contact_mobile}</td>
              <td>{vo.custumer_company_email}</td>
              <td>{vo.custumer_contact_firstname}</td>
              <td>{vo.custumer_contact_lastname}</td>
              <td>
                {/* Check if qrCode exists and render as image */}
                {vo.qrCode ? (
  <a href={`${batchURI}${vo.fetch_url_hash}`} target="_blank" rel="noopener">
    <img
      src={`data:image/png;base64,${vo.qrCode}`}
      alt="QR Code"
      style={{ width: '100px', height: '100px' }}
    />
  </a>
) : (
  'No QR Code available'
)}

              </td>
              <td style={{ whiteSpace: 'nowrap' }}>{vo.rec_dat}</td>
              <td>
              <ButtonGroup>
                {/*<Button variant="warning" onClick={() => handleEditClick(vo)} className="mr-2">
                  Edit
                </Button>
                <Button variant="danger" onClick={(e) => handleDeleteClick(vo.customer_id,e)}>
                  Delete
                </Button>*/}
                <Button variant="success" onClick={(e) => handleNotificationClick(vo.customer_id,e)} className="mr-2">
                  Send Access Data
                </Button>
                
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>

      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formCompanyName">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company name"
                name="custumer_company_name"
                value={formData.custumer_company_name}
                onChange={handleChange}
                isInvalid={!!errors.custumer_company_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_company_name}
              </Form.Control.Feedback>
            </Form.Group>

     

            <Form.Group controlId="formCompanyMobile">
              <Form.Label>Company Mobile Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company mobile number"
                name="custumer_contact_mobile"
                value={formData.custumer_contact_mobile}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_contact_mobile}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_contact_mobile}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCompanyEmail">
              <Form.Label>Company Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter company email"
                name="custumer_company_email"
                value={formData.custumer_company_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_company_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_company_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactFirstName">
              <Form.Label>Contact First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact first name"
                name="custumer_contact_firstname"
                value={formData.custumer_contact_firstname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_contact_firstname}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_contact_firstname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactLastName">
              <Form.Label>Contact Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact last name"
                name="custumer_contact_lastname"
                value={formData.custumer_contact_lastname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_contact_lastname}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_contact_lastname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactMobile">
              <Form.Label>Contact Postal Code Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact mobile number"
                name="custumer_postal_code"
                value={formData.custumer_postal_code}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_postal_code}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_postal_code}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city"
                name="custumer_city"
                value={formData.custumer_city}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_city}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_city}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>City add</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city add"
                name="custumer_city_add"
                value={formData.custumer_city_add}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_city_add}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_city_add}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Street</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street"
                name="custumer_str"
                value={formData.custumer_str}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_str}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_str}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Street number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street number"
                name="custumer_street_number"
                value={formData.custumer_street_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_street_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_street_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Street add</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street add"
                name="custumer_street_add"
                value={formData.custumer_street_add}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_street_add}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_street_add}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Tax number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tax number"
                name="custumer_tax_number"
                value={formData.custumer_tax_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_tax_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_tax_number}
              </Form.Control.Feedback>
            </Form.Group>
           
         

            <Form.Group controlId="formContactEmail">
              <Form.Label>Tax ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tax id"
                name="custumer_tax_id"
                value={formData.custumer_tax_id}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_tax_id}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_tax_id}
              </Form.Control.Feedback>
            </Form.Group>
   
            <Form.Group controlId="formSubVo">
        <Form.Label>Select Tariff</Form.Label>
        <Form.Control
          as="select"
          name="tariff_id"
          value={formData.tariff_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.tariff_id}
        >
          <option value="">Select Tariff</option>
          {Array.isArray(tariffs) && tariffs.map(mvos => (
            <option key={mvos.tariff_id} value={mvos.tariff_id}>
              {mvos.tariff_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.tariff_id}
              </Form.Control.Feedback>
              
      </Form.Group>


      <Form.Group controlId="formSubVo">
        <Form.Label>Select Batch Status</Form.Label>
        <Form.Control
          as="select"
          name="batch_status_id"
          value={formData.batch_status_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.batch_status_id}
        >
          <option value="">Select Batch Status</option>
          {statuses.map(mvos => (
            <option key={mvos.status_id} value={mvos.status_id}>
              {mvos.status_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.batch_status_id}
              </Form.Control.Feedback>
              
      </Form.Group>

{/* Batch Validity From Date Field */}
<Form.Group controlId="formBatchValidityFrom">
        <Form.Label>Batch Validity From</Form.Label>
        <Form.Control
          type="date"
          name="batch_validity_from"
          value={formData.batch_validity_from}
          onChange={handleChange}
          isInvalid={!!errors.batch_validity_from}
        />
        <Form.Control.Feedback type="invalid">
          {errors.batch_validity_from}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Batch Validity Until Date Field */}
      <Form.Group controlId="formBatchValidityUntil">
        <Form.Label>Batch Validity Until</Form.Label>
        <Form.Control
          type="date"
          name="batch_validity_until"
          value={formData.batch_validity_until}
          onChange={handleChange}
          isInvalid={!!errors.batch_validity_until}
        />
        <Form.Control.Feedback type="invalid">
          {errors.batch_validity_until}
        </Form.Control.Feedback>
      </Form.Group>


            <Form.Group controlId="formSubVo">
        <Form.Label>Select Place</Form.Label>
        <Form.Control
          as="select"
          name="place_id_nr"
          value={formData.t_place_id.place_id_nr}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.place_id_nr}
        >
          <option value="">Select Place</option>
          {places.map(mvos => (
            <option key={mvos.place_id_nr} value={mvos.place_id_nr}>
              {mvos.place_id}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.place_id_nr}
              </Form.Control.Feedback>
              
      </Form.Group>


      {currentUser.roles.includes("ROLE_ADMIN") && (
            <Form.Group controlId="formSubVo">
        <Form.Label>Select Sub VO</Form.Label>
        <Form.Control
          as="select"
          name="sub_vo_id"
          value={formData.t_sub_vo.sub_vo_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.sub_vo_id}
        >
          <option value="">Select Sub VO</option>
          {subvos.map(mvos => (
            <option key={mvos.sub_vo_id} value={mvos.sub_vo_id}>
              {mvos.company_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.main_vo_id}
              </Form.Control.Feedback>
              
      </Form.Group>
    )}

            <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Saving...' : 'Saving Customer'}
              
            </Button>
            
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
          <Form.Group controlId="formCompanyName">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company name"
                name="custumer_company_name"
                value={formData.custumer_company_name}
                onChange={handleChange}
                isInvalid={!!errors.custumer_company_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_company_name}
              </Form.Control.Feedback>
            </Form.Group>

     

            <Form.Group controlId="formCompanyMobile">
              <Form.Label>Company Mobile Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company mobile number"
                name="custumer_contact_mobile"
                value={formData.custumer_contact_mobile}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_contact_mobile}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_contact_mobile}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCompanyEmail">
              <Form.Label>Company Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter company email"
                name="custumer_company_email"
                value={formData.custumer_company_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_company_email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_company_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactFirstName">
              <Form.Label>Contact First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact first name"
                name="custumer_contact_firstname"
                value={formData.custumer_contact_firstname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_contact_firstname}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_contact_firstname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactLastName">
              <Form.Label>Contact Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact last name"
                name="custumer_contact_lastname"
                value={formData.custumer_contact_lastname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_contact_lastname}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_contact_lastname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactMobile">
              <Form.Label>Contact Postal Code Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact mobile number"
                name="custumer_postal_code"
                value={formData.custumer_postal_code}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_postal_code}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_postal_code}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city"
                name="custumer_city"
                value={formData.custumer_city}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_city}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_city}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>City add</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city add"
                name="custumer_city_add"
                value={formData.custumer_city_add}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_city_add}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_city_add}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Street</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street"
                name="custumer_str"
                value={formData.custumer_str}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_str}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_str}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Street number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street number"
                name="custumer_street_number"
                value={formData.custumer_street_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_street_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_street_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Street add</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street add"
                name="custumer_street_add"
                value={formData.custumer_street_add}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_street_add}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_street_add}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formContactEmail">
              <Form.Label>Tax number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tax number"
                name="custumer_tax_number"
                value={formData.custumer_tax_number}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_tax_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_tax_number}
              </Form.Control.Feedback>
            </Form.Group>
           
            <Form.Group controlId="formContactEmail">
              <Form.Label>Tax ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tax id"
                name="custumer_tax_id"
                value={formData.custumer_tax_id}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.custumer_tax_id}
              />
              <Form.Control.Feedback type="invalid">
                {errors.custumer_tax_id}
              </Form.Control.Feedback>
            </Form.Group>
   
            <Form.Group controlId="formSubVo">
        <Form.Label>Select Tariff</Form.Label>
        <Form.Control
          as="select"
          name="tariff_id"
          value={formData.tariff_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.tariff_id}
        >
          <option value="">Select Tariff</option>
          {Array.isArray(tariffs) && tariffs.map(mvos => (
            <option key={mvos.tariff_id} value={mvos.tariff_id}>
              {mvos.tariff_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.tariff_id}
              </Form.Control.Feedback>
              
      </Form.Group>


      <Form.Group controlId="formSubVo">
        <Form.Label>Select Batch Status</Form.Label>
        <Form.Control
          as="select"
          name="batch_status_id"
          value={formData.batch_status_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.batch_status_id}
        >
          <option value="">Select Batch Status</option>
          {statuses.map(mvos => (
            <option key={mvos.status_id} value={mvos.status_id}>
              {mvos.status_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.batch_status_id}
              </Form.Control.Feedback>
              
      </Form.Group>

{/* Batch Validity From Date Field */}
<Form.Group controlId="formBatchValidityFrom">
        <Form.Label>Batch Validity From</Form.Label>
        <Form.Control
          type="date"
          name="batch_validity_from"
          value={formData.batch_validity_from}
          onChange={handleChange}
          isInvalid={!!errors.batch_validity_from}
        />
        <Form.Control.Feedback type="invalid">
          {errors.batch_validity_from}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Batch Validity Until Date Field */}
      <Form.Group controlId="formBatchValidityUntil">
        <Form.Label>Batch Validity Until</Form.Label>
        <Form.Control
          type="date"
          name="batch_validity_until"
          value={formData.batch_validity_until}
          onChange={handleChange}
          isInvalid={!!errors.batch_validity_until}
        />
        <Form.Control.Feedback type="invalid">
          {errors.batch_validity_until}
        </Form.Control.Feedback>
      </Form.Group>

            <Form.Group controlId="formSubVo">
        <Form.Label>Select Place</Form.Label>
        <Form.Control
          as="select"
          name="place_id_nr"
          value={formData.place_id_nr}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.place_id_nr}
          style={{ pointerEvents: "none", backgroundColor: "lightgray" }} 
        >
         <option value="">Select Place</option>
         <option value={formData.place_id_nr}>{formData.t_place_id.place_id}</option>
          {places.map(mvos => (
            <option key={mvos.place_id_nr} value={mvos.place_id_nr}>
              {mvos.place_id}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.place_id_nr}
              </Form.Control.Feedback>
              
      </Form.Group>

      {currentUser.roles.includes("ROLE_ADMIN") && (
            <Form.Group controlId="formSubVo">
        <Form.Label>Select Sub VO</Form.Label>
        <Form.Control
          as="select"
          name="sub_vo_id"
          value={formData.t_sub_vo.sub_vo_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.sub_vo_id}
        >
          <option value="">Select Sub VO</option>
          
          {subvos.map(mvos => (
            <option key={mvos.sub_vo_id} value={mvos.sub_vo_id}>
              {mvos.company_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.main_vo_id}
              </Form.Control.Feedback>
              
      </Form.Group>
         )}
            <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Updating...' : 'Update Customer'}
            </Button>
           
          </Form>
        </Modal.Body>
      </Modal>
      </div>
    </Container>
  );
};

export default BoardCustomer;